import DailyListingStatistic from 'app/shared/model/DailyListingStatistic';

const Statistic = ({
    singleListing = false,
    monthlySummariesUnavailable = false,
    dailyBillableCountsAvailable = false,
    monthlyBillableCountsAvailable = false,
    monthlyListingStatsByYyyyMm = {},
    dailyListingStatsByYyyyMmDd = {},
    dailyListingStats = {},
    listingTitle = '',
} = {}) => ({
    singleListing: Boolean(singleListing),
    monthlySummariesUnavailable: Boolean(monthlySummariesUnavailable),
    dailyBillableCountsAvailable: Boolean(dailyBillableCountsAvailable),
    monthlyBillableCountsAvailable: Boolean(monthlyBillableCountsAvailable),
    monthlyListingStatsByYyyyMm: Object(monthlyListingStatsByYyyyMm), // dynamic key
    dailyListingStatsByYyyyMmDd: Object(dailyListingStatsByYyyyMmDd), // dynamic key
    dailyListingStats: DailyListingStatistic(dailyListingStats),
    listingTitle: String(listingTitle),
});

export default Statistic;
